import i from './snackbar.container';

export default i;
